import { bigIntify } from './conversion.js'

export const ONE_PERCENT = 100n
export const ONE_HUNDRED_PERCENT = 10000n

export const percent_mul = (amount, percent) => {
  return bigIntify((amount * percent) / ONE_HUNDRED_PERCENT)
}
